/**
 * Profile detail component created by karora on 24/06/17.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { AppComponent } from '../app.component';
import { ApiService } from '../services/api.service';
import { ProfileService } from '../services/profile.service';
import { UserProfile } from '../types/user-profile';


@Component({
  selector: 'profile-detail',
  template: `<div *ngIf="CanAdminister; else notAdmin;">
  <ng-container *ngIf="!!profile">
    <div class="picture"><img src="{{profile.social.picture}}"></div>
    <div id="profile-detail-component">
      <div class="bigfield"><span class="h2">{{profile.social.name}}</span></div>
      <div class="field"><label>email: </label>{{profile.social.email}}</div>
      <div class="toggleField" (click)="toggleAdminister()"><label>administer: </label>
        <ng-container *ngIf="!!profile.administer; else noAdminRights">
          <mat-icon class="md-48" color="primary" aria-label="Remove administrator rights" >check_circle_outline</mat-icon>
        </ng-container>
        <ng-template #noAdminRights>
          <mat-icon class="md-48" color="warn" aria-label="Add administrator rights">highlight_off</mat-icon>
        </ng-template>
      </div>
      <div class="toggleField" (click)="toggleRight('firmware')"><label>control firmware: </label>
        <ng-container *ngIf="!!profile.rights['firmware']; else noFirmwareRight">
          <mat-icon class="md-48" color="primary" aria-label="Remove right" >check_circle_outline</mat-icon>
        </ng-container>
        <ng-template #noFirmwareRight>
          <mat-icon class="md-48" color="warn" aria-label="Add right">highlight_off</mat-icon>
        </ng-template>
      </div>
      <div class="toggleField" (click)="toggleRight('address')"><label>view addresses: </label>
        <ng-container *ngIf="!!profile.rights['address']; else noAddressRight">
          <mat-icon class="md-48" color="primary" aria-label="Remove right" >check_circle_outline</mat-icon>
        </ng-container>
        <ng-template #noAddressRight>
          <mat-icon class="md-48" color="warn" aria-label="Add right">highlight_off</mat-icon>
        </ng-template>
      </div>
    </div>
  </ng-container>
  <ng-template #loading>
    Loading...
  </ng-template>
</div>
<ng-template #notAdmin>
  <p>You must be an administrator to access this screen.</p>
</ng-template>
<div *ngIf="errorMessage">
<p clss="error">{{errorMessage}}</p>
</div>
`,
  styles: [
    `#profile-detail-component { background-color: whitesmoke; min-width: 35em; padding: 0.3em 0.2em; display: inline-block;}`,
    `label { display: inline-block; width: 9em; }`,
    `.picture { float: right; right: 0; top: 0; }`,
    `.picture img { width: 256px; height: 256px; }`,
    `h2, .h2 { font-size: 1.5em; color: #456; font-family: Arial, Helvetica, sans-serif; font-weight: lighter; }`,
    `.field { display: block; height: 1.5em; margin-top: 0.2em; }`,
    `.bigfield { display: block; height: 2.2em; margin-bottom: 0.3em; }`,
    `.toggleField { display: block; height: inherit; padding: 0.3em 0; }`,
    `.toggleField label { position: relative; bottom: 10px; left: 0; }`,
  ],
  providers: [ ProfileService ],
})

export class ProfileDetailComponent implements OnInit {
  CanAdminister = ProfileService.CanAdminister;
  profile: UserProfile;
  errorMessage: string;
  private myProfile: UserProfile;

  constructor(
    private profileService: ProfileService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    if (!ApiService.IsLoggedIn()) { return; }
    this.profileService.GetProfile().subscribe(
      profile => this.myProfile = profile,
      error => this.errorMessage = <any>error,
    );
    console.log('Getting profile detail.');
    this.route.params.subscribe(
      (params: Params) => this.getProfile(params['profile_type'], params['profile_id'])
    );
  }

  getProfile(type: number, id: string): void {
    this.profileService.OneProfile(type, id).subscribe(
        profile => this.setProfile(profile),
        error => this.errorMessage = <any>error,
      );
  }

  setProfile(profile: UserProfile) {
    console.log('Loaded profile ' + profile.social.name + '(' + profile.id + ')');
    this.profile = profile;
    AppComponent.SetTitle(profile.social.name);
  }

  toggleAdminister(): void {
    if (this.profile.id === this.myProfile.id) {
      alert('You can\'t remove your own administrator rights!');
    } else {
      this.profile.administer = !this.profile.administer;
      this.updateProfile();
    }
  }

  toggleRight(right: string): void {
      this.profile.rights[right] = !this.profile.rights[right];
      this.updateProfile();
  }

  updateProfile() {
    if (!this.CanAdminister()) {
      this.errorMessage = 'You need admin rights to change these settings';
      return;
    }
    this.profileService.UpdateProfile(this.profile)
      .subscribe(
        profile => this.getProfile(this.profile.type, this.profile.id),
        error => this.errorMessage = <any>error,
      );
  }

}
